import { Route } from "components/utils";
import { Dashboard as HRDashboard } from "pages/humanResources/dashboard/Dashboard";
import { NotFound } from "pages/notFound";
import { RouteComponentProps, Switch } from "react-router-dom";

export const Dashboard = ({ match }: RouteComponentProps): JSX.Element => {
  return (
    <Switch>
      <Route
        component={HRDashboard}
        exact={true}
        path={`${match.path}`}
        title="Milo - kadry"
      />
      <Route component={NotFound} exact={true} path="*" title="Milo" />
    </Switch>
  );
};
